'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeAllReducer = exports.removeAllActionCreator = undefined;

var _yourchoice = require('yourchoice');

var _actionTypes = require('./actionTypes');

var removeAllActionCreator = function removeAllActionCreator(selectionName) {
  return {
    type: _actionTypes.REMOVE_ALL,
    payload: {
      selectionName: selectionName
    }
  };
};

function removeAllReducer(payload, currentSelection) {
  return (0, _yourchoice.removeAll)(currentSelection);
}

exports.removeAllActionCreator = removeAllActionCreator;
exports.removeAllReducer = removeAllReducer;


//////////////////
// WEBPACK FOOTER
// ./~/yourchoice-redux/lib/removeAll.js
// module id = 72
// module chunks = 0